import { z } from 'zod'

// These config schemas were previously defined in the document-sources package
// but were moved here to enable us to use them in the generated schema.ts in the postgres package
// Look at .kysely-codegenrc.ts in the postgres package to see how it's being used for the generated schema

export const TripletexConfigSchema = z.object({
	type: z.literal('tripletex'),
	employeeToken: z.string(),
	consumerToken: z.string().optional(),
	webhookToken: z.string(),
	subscriptionIds: z.array(z.number()),
	version: z.number(),
})

export const PowerOfficeGoConfigSchema = z.object({
	type: z.literal('power-office-go'),
	clientKey: z.string(),
})

export const TwentyFourSevenOfficeConfigSchema = z.object({
	type: z.literal('24seven-office'),
	identityId: z.string().optional(),
})

export const FileUploadConfigSchema = z.object({
	type: z.literal('file-upload'),
	fileId: z.string().optional(),
})

export const DocumentSourceConfigSchema = z.discriminatedUnion('type', [
	TripletexConfigSchema,
	PowerOfficeGoConfigSchema,
	TwentyFourSevenOfficeConfigSchema,
	FileUploadConfigSchema,
])

export type DocumentSourceConfig = z.infer<typeof DocumentSourceConfigSchema>
